<script setup lang="ts">
const { appVersion } = useRuntimeConfig().public
const currentYear = new Date().getFullYear()
const route = useRoute()
const isHomepage = computed(() => route.path === '/')

const links = [
  { label: 'Kontakt', to: '/kontakt' },
  { label: 'Blog', to: '/blog' },
  { label: 'Pro veterináře', to: '/pro-veterinare' },
  { label: 'Premium', to: '/predplatne' },
  { label: 'Ochrana údajů', to: '/ochrana-udaju' },
  { label: 'Obchodní podmínky', to: '/podminky' },
  { label: 'Spolupracujeme', to: '/spolupracujeme' },
]
</script>

<template>
  <footer class="border-t border-default bg-muted">
    <div class="container mx-auto px-4 py-8">
      <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-2 text-muted">
          <UIcon name="i-lucide-heart-pulse" class="size-8 text-primary" />
          <span class="text-base">&copy; {{ currentYear }} Veterina Pohotovost</span>
          <NuxtLink to="/changelog" class="text-xs text-dimmed hover:text-muted transition-colors">
            v{{ appVersion }}
          </NuxtLink>
        </div>

        <div v-if="isHomepage">
          <a href="https://www.toplinks.cz" title="TOPLINKs.CZ - katalog odkazů" class="text-xs text-dimmed hover:text-muted transition-colors">Katalog TopLinks.cz</a>
        </div>

        <nav class="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <NuxtLink
            v-for="link in links"
            :key="link.to"
            :to="link.to"
            class="text-base text-muted hover:text-highlighted transition-colors"
          >
            {{ link.label }}
          </NuxtLink>
          <UColorModeButton size="xs" />
        </nav>
      </div>
    </div>
  </footer>
</template>
